import React from "react";

import { useNavigate } from "react-router-dom";
import { StartConversation } from "../Casinoengine/StartConversation";

const CasinoPlatform = () => {
  const navigate = useNavigate();
  const featuresData = [
    {
      title: "Customizable Front-End Powered by APIs",
      description:
        "Deliver personalized, localized casino experiences with flexible front-end architecture that enables operators to bring their creative vision to life.",
    },
    {
      title: "Advanced Productivity Tools",
      description:
        "Access key performance metrics, manage game assets, and build audience-targeted lobbies effortlessly to boost operational efficiency and revenue.",
    },
    {
      title: "Comprehensive Real-Time Reporting",
      description:
        "Gain actionable insights with multidimensional reports and real-time visibility down to game rounds and transactions for smarter decision-making.",
    },
    {
      title: "Flexible Bonusing & Gamification",
      description:
        "Powered by BonusEngine, our standalone bonusing system helps operators drive player acquisition and retention across any product.",
    },
  ];

  return (
    <>
      <main className="overflow-hidden">
        <section class="simple-intro">
          <div class="container container_custom">
            <div class="row align-items-center justify-content-between">
              <div class="col-xl-5 col-lg-6">
                <h1 class="section-title heading_left">
                Comprehensive Managed Casino Platform
                </h1>
                <div class="description">
                  <p>
                  We offer a fully managed, robust online casino platform, purpose-built to meet our clients’ unique needs. Designed with operators in mind, this proven solution empowers full control over all aspects of casino operations.
                  </p>
                </div>
                <div class="btns pt-5">
                  <a href="/connect" class="btn btn_blue">
                    Contact us
                  </a>
                </div>
              </div>
              <div class="col-md-6">
                <img
                  src="https://everymatrix.com/wp-content/uploads/2019/11/CE-Turn-key-Solution-img1-1.png"
                  class="illustration"
                />
              </div>
            </div>
          </div>
          <a href="#explore" class="explore"></a>
        </section>

        <section>
          <section className="features">
            <div className="container">
              <div className="row">
                {featuresData.map((item, index) => (
                  <div className="col" key={index}>
                    <div className="inner">
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </section>
      <div style={{marginTop:'20px'}}>
      <StartConversation />
      </div>
       
      </main>
    </>
  );
};

export default CasinoPlatform;
